function users() {
	const elId = '#app-users';
	const elClass = '.js-vue-users';

	if ($(elId).length == 0 || $(elClass).length == 0) {
		return;
	}

	const headerHandicap = 1;

	const app = new Vue({
		el: elId,
		data: {
			search: {
				field: null,
				currentkeyword: null
			},
			results: {
				found: 0,
				count: 0,
				items: [],
				fullitems: [],
				selected: null,
				selectedIndex: -1
			},
			pagination: {
				max: 999,
				pagesize: 10,
				currentpage: 0
			},
			modal: null,
			error: null
		},
		created: function() {
			const self = this;
			toggleLoader(true);
			this.fetchData();

			window.onpopstate = function(event) {
				console.log(`location: ${document.location}, state: ${JSON.stringify(event.state)}`);
				if (event && event.state && event.state.page == 'user') {
					self.selectItem(event.state.item, event.state.index, true);
				} else {
					self.error = null;
					self.results.selected = null;
					self.results.selectedIndex = null;
					localStorage.removeItem('users:selectedIndex');
				}
			};

			if (history && history.state && history.state.page == 'user') {
				this.selectItem(history.state.item, history.state.index, true);
			}
		},
		mounted: function() {
			$(elClass).removeClass('is-mounting');
		},
		methods: {
			fetchData: function() {
				const self = this;
				GET('/baas/nominow_management/allusers')
					.then(xhr => {
						self.error = null;
						let data = JSON.parse(xhr.responseText);
						data.splice(0, 0, {
							UserGuid: 0,
							FirstName: 140,
							Surname: 100,
							EmailAddress: 50,
							UserName: 200,
							IsActive: 130,
							LastLogin: 30
						});
						data = data.map(el => {
							el.LastLogin = window.formatDateTime(el.LastLogin);
							return el;
						});
						self.results.items = data;
						self.results.fullitems = data;
						self.results.count = data.length - headerHandicap;
						$(elClass).removeClass('is-creating');
						toggleLoader(false);
					})
					.catch(xhr => {
						self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
						$(elClass).removeClass('is-creating');
					});
			},
			doSearch: function() {
				const self = this;
				/* in this case, we're searching the existing list instead of making a get call, so there's no loading going on in this search function */
				if (isLoading() || self.search.field == null) {
					return;
				}
				self.search.currentkeyword = self.search.field;
				const search = this.search.currentkeyword.toLowerCase();
				if (!search) {
					self.results.items = self.results.fullitems;
					self.results.found = 0;
					self.search.currentkeyword = null;
				} else {
					const newUsers = [];
					/* header */
					newUsers.push(self.results.fullitems[0]);

					for (let i = 1; i < self.results.fullitems.length; i++) {
						const q = self.results.fullitems[i];
						const arr = Array.prototype.map.call(Object.keys(q), a => q[a]);
						let txt = Array.prototype.join.call(arr, ' ');
						txt = txt.toLowerCase();
						if (txt.indexOf(search) > -1) {
							newUsers.push(q);
						}
					}
					self.results.items = newUsers;
					self.results.found = newUsers.length - headerHandicap;
				}
				self.pagination.currentpage = 0;
			},
			selectItem: function(item, ix, nostate) {
				ix += this.pagination.currentpage * this.pagination.pagesize;
				localStorage.setItem('users:selectedIndex', ix);
				if (item.Roles == null || item.Roles.length == 0) {
					item.Roles = [];
					item.Roles.push({});
				}
				this.results.selected = item;
				this.results.selectedIndex = ix;
				if (!nostate) {
					history.pushState(
						{
							page: 'user',
							item: item,
							index: ix
						},
						'Detail - Users - Nominow',
						'/app/users/user'
					);
				}
			},
			deselectItem: function() {
				history.go(-1);
			},
			getLabel: function(genderId) {
				if (genderId == 1) {
					return 'Male';
				}
				if (genderId == 2) {
					return 'Female';
				}
				return '- Choose -';
			},
			saveUser: function() {
				if (isLoading()) {
					return;
				}
				toggleLoader(true);
				const self = this;
				const user = this.results.selected;
				const postedUser = {
					user: user
				};

				if (user.UserGuid == null) {
					POST('/baas/Nominow_Management/createuser', postedUser)
						.then(xhr => {
							const response = JSON.parse(xhr.responseText);
							if (response.Message) {
								window.initToast(xhr.responseText != '' ? xhr.responseText : timeOutResponseText, 'error');
								toggleLoader(false);
							} else {
								self.error = null;
								self.deselectItem();
								self.fetchData();
								toggleLoader(false);
								window.initToast('Saved!', 'success');
							}
						})
						.catch(xhr => {
							self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
							toggleLoader(false);
						});
				} else {
					PUT('/baas/nominow_management/saveuser', postedUser)
						.then(xhr => {
							self.error = null;
							self.deselectItem();
							self.fetchData();
							toggleLoader(false);
							window.initToast('Saved!', 'success');
						})
						.catch(xhr => {
							self.error = xhr.responseText != '' ? xhr.responseText : timeOutResponseText;
							toggleLoader(false);
						});
				}
			},
			deleteUser: function() {
				const self = this;
				if (this.results.selected.UserGuid != null) {
					this.modal = window.deleteConfirmComponent(self, () => {
						toggleLoader(true);
						DELETE(`/baas/nominow_management/deleteuser?UserGuid=${self.results.selected.UserGuid}`).then(
							() => {
								self.error = null;
								self.deselectItem();
								self.fetchData();
								toggleLoader(false);
								window.initToast('User deleted', 'success');
							},
							() => {
								toggleLoader(false);
								window.initToast('Delete of user failed', 'error');
							}
						);
						self.modal = null;
					});
				}
			},
			closemodals: function() {
				this.modal = null;
			},
			newUser: function() {
				const newUser = {};
				newUser.Roles = [];
				newUser.Roles.push({});
				this.results.selected = newUser;
				this.results.selectedIndex = -1;
			}
		}
	});
	/* App is added as window.activeRootComponent so that it can be used by helpers, such as the keyup helper. */
	window.activeRootComponent = app;
}
users();
